// extracted by mini-css-extract-plugin
export default {"root":"style_root__NdB9F","buttonContainer":"style_buttonContainer__BezfS","noButton":"style_noButton__+7vgd"};